import { inject, reactive, ref, provide, computed } from 'vue';

import Card from '@/components/content/views/card/card.vue';
import Tooltip from '@/components/content/views/tooltip/tooltip.vue';
import FormattingService from '@/services/formatting.service';
import SkeletonLoader from '@/components/content/views/skeleton-loader/skeleton-loader.vue';
import Modal from '@/components/content/views/modal/modal.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFileLines, faFilePdf } from '@fortawesome/free-solid-svg-icons';

library.add(faFileLines);
library.add(faFilePdf);

export default {
  name: 'Magazine',
  props: {
    user: {
      type: Object,
      required: false
    },
    item: {
      type: Object,
      required: true,
    },
  },
  components: {
    Card,
    SkeletonLoader,
    FontAwesomeIcon,
    Tooltip,
  },
  setup(props) {
    const body = ref(null);
    const title = ref(null);
    const image = ref(null);
    const view = ref(null);
    const files = ref(null);
    const download = ref(null);
    const state = reactive({
      member: computed(() => props.user),
      item: computed(() => props.item),
      width: 0,
      excerpt: computed(() => {
        let charCount = Math.floor(state.width / 10) * 3;
        if(charCount > state.item.article.excerpt.length) {
          return state.item.article.excerpt;
        }
        return state.item.article.excerpt.substring(0, charCount)+'...'
      }),
      imageUrl: computed(() => {
        if(!state.item.images) return '';
        if(state.item.images['480w']) return state.item.images['480w'];
        if(state.item.images['536w']) return state.item.images['536w'];
        if(state.item.images['540w']) return state.item.images['540w'];
        if(state.item.images['600w']) return state.item.images['600w'];
        if(state.item.images['750w']) return state.item.images['750w'];
        if(state.item.images['768w']) return state.item.images['768w'];
        return state.item.images.full;
      }),
      showOverlay: computed(() => (state.item.pdf || state.item.viewer || state.item.downloads) ? false : true),
      showOverlayText: false,
      isVipContent: computed(() => {
        if (state.item && state.item.tiers) {
          if (state.item.tiers.includes(1060) && !state.item.tiers.includes(1)) {
            return true;
          }
        }

        return false;
      }),
    });

    return {
      state,
      FormattingService,
      body,
      image,
      title,
      view,
      files,
      download,
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
    this.state.width = this.body.clientWidth;
    this.image.addEventListener('click', () => {
      dataLayer.push({'gaMagazineIssue': this.state.item.title});
    })
    this.title.addEventListener('click', () => {
      dataLayer.push({'gaMagazineIssue': this.state.item.title});
    })
    this.view.addEventListener('click', () => {
      dataLayer.push({'gaMagazineIssue':this.state.item.title});
    })
    this.files.addEventListener('click', () => {
      dataLayer.push({'gaMagazineIssue': this.state.item.title});
    })
    this.download.addEventListener('click', () => {
      dataLayer.push({'gaMagazineIssue': this.state.item.title});
    })
  },
  methods: {
    toggleModal(item) {
      this.$emit('toggleModal', item);
    },
    onResize() {
      this.state.width = this.body.clientWidth;
    },
  }
}
